import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { PRODUCTIONS } from "../../data/content";

export const Productions = () => {
  const [active, setActive] = useState(PRODUCTIONS.length - 1);

  return (
    <section id="productions" data-testid="productions-section" className="relative py-28 lg:py-40 bg-[#040404]">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8">
        <div className="mb-16">
          <Reveal><Overline>Stage & Screen</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter max-w-3xl">
              Bringing faith-filled stories <span className="text-gold-gradient italic">to life</span>
            </h2>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          {/* Spotlight image frame */}
          <div className="lg:sticky lg:top-28">
            <div className="relative aspect-[4/5] overflow-hidden rounded-sm border border-gold/20 bg-black">
              <AnimatePresence mode="wait">
                <motion.img
                  key={active}
                  src={PRODUCTIONS[active].image}
                  alt={PRODUCTIONS[active].title}
                  initial={{ opacity: 0, scale: 1.08 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </AnimatePresence>
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
              {/* stage spotlight */}
              <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(60% 50% at 50% 0%, rgba(212,175,55,0.18), transparent 70%)" }} />
              <div className="absolute bottom-0 left-0 p-8">
                <span className="text-gold text-xs uppercase tracking-[0.3em]">{PRODUCTIONS[active].year}</span>
                <h3 className="font-serif text-4xl lg:text-5xl font-light mt-2">{PRODUCTIONS[active].title}</h3>
                <p className="text-white/60 text-sm mt-2">{PRODUCTIONS[active].kind}</p>
              </div>
            </div>
          </div>

          {/* Production list */}
          <div className="flex flex-col">
            {PRODUCTIONS.map((p, i) => (
              <button
                key={p.title}
                data-testid={`production-${i}`}
                onMouseEnter={() => setActive(i)}
                onFocus={() => setActive(i)}
                onClick={() => setActive(i)}
                className={`group text-left py-7 border-t border-white/10 last:border-b transition-colors duration-500 ${
                  active === i ? "opacity-100" : "opacity-55 hover:opacity-90"
                }`}
              >
                <div className="flex items-baseline justify-between gap-4">
                  <div className="flex items-baseline gap-5">
                    <span className="font-mono text-xs text-gold/70 w-10">{p.year}</span>
                    <h3 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-light tracking-tight">
                      {p.title}
                      {p.featured && (
                        <span className="ml-3 align-middle text-[10px] uppercase tracking-[0.25em] text-black bg-gold px-2 py-0.5 rounded-sm">New</span>
                      )}
                    </h3>
                  </div>
                  <span
                    className={`font-serif text-3xl leading-none transition-transform duration-500 ${
                      active === i ? "text-gold translate-x-0" : "text-white/20 -translate-x-2 group-hover:translate-x-0"
                    }`}
                  >
                    →
                  </span>
                </div>
                <p className="mt-2 pl-[3.75rem] text-sm text-white/45">{p.kind}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
